<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getConsolidationUsers.length > 0 && $store.getters.getConsolidationUsersLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'forbiddenKeywords_Id',
            'consolidationUsers_Name',
            'forbiddenKeywords_Status',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('forbiddenKeywords_Id.localization_value.value') }}</th>
            <th>{{ $t('consolidationUsers_Name.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getConsolidationUsers" :key="index">
            <td>
              #{{item.id}}
            </td>

            <td>
              {{item.name}}
            </td>
            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_edit.localization_value.value')"
                            :type="'edit'"
                            @click.native="changeConsolidationUsersPopup(true, item.id)"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getConsolidationUsers"
                 :key="index"
            >
              <ConsolidationUsersTableMobile
                      :item="item"
                      @changeConsolidationUsersPopup="changeConsolidationUsersPopup(true, item.id)"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getConsolidationUsersCommonList.next_page_url !== null && $store.getters.getConsolidationUsers.length > 0"
                    @click.native="$emit('showMore')"
                    :count="$store.getters.getConsolidationUsersCommonList.total - $store.getters.getConsolidationUsersForPage * $store.getters.getConsolidationUsersCommonList.current_page < $store.getters.getConsolidationUsersForPage ?
                    $store.getters.getConsolidationUsersCommonList.total - $store.getters.getConsolidationUsersForPage * $store.getters.getConsolidationUsersCommonList.current_page :
                    $store.getters.getConsolidationUsersForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getConsolidationUsersLoading === false && $store.getters.getConsolidationUsers.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <ConsolidationUsersPopup
            v-if="isModalConsolidationUsersPopup"
            :itemId="itemId"
            :type="'update'"
            @reload="$emit('reload')"
            @close="changeConsolidationUsersPopup(false)"
    />
  </div>
</template>

<script>
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import ConsolidationUsersPopup from "../../../../popups/ConsolidationUsersPopup/ConsolidationUsersPopup";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import ConsolidationUsersTableMobile from "./ConsolidationUsersTableMobile/ConsolidationUsersTableMobile";

  export default {
    name: "ConsolidationUsersTable",
    components: {
      ConsolidationUsersTableMobile,
      NoResult,
      ManagerButton,
      LinkButton,
      ShowMore,
      ConsolidationUsersPopup,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalConsolidationUsersPopup: false,

      }
    },

    methods: {
      changeConsolidationUsersPopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalConsolidationUsersPopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteConsolidationUsers', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
